import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Container,
  Typography,
  Divider,
  Stack,
  Grid,
  CircularProgress,
  InputLabel,
  Link,
  Breadcrumbs,
  Skeleton,
} from "@common-ui/ui";

import { useParams, useHistory, Link as RouterLink } from "react-router-dom";
import { Edit } from "@mui/icons-material";
import InsertPhotoOutlinedIcon from "@mui/icons-material/InsertPhotoOutlined";
import { UserOrgsTable } from "./UserOrgsTable";
import {
  getOrg,
  getOrgProfileImage,
  // listToTree,
} from "../../services";

export const ViewSingleOrg = ({ unfilteredData }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [imageUrl, setImageUrl] = useState("");
  const [orgImageFileType, setOrgImageFileType] = useState("");
  const [breadcrumbData, setBreadcrumbData] = useState([]);
  const [currentOrgData, setCurrentOrgData] = useState(null);
  let router = useHistory();
  let params = useParams();

  const getBreadcrumbData = (crumbs, payload, mainData) => {
    if (!payload.parent) {
      const data = [payload, ...crumbs];
      return data;
    }
    const newCrumbs = [payload, ...crumbs];
    const newPayload = unfilteredData.find(
      (data) => data.id === payload.parent
    );
    return getBreadcrumbData(newCrumbs, newPayload, mainData);
  };
  useEffect(() => {
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id, unfilteredData]);
  async function init() {
    try {
      if (!params.id) return;

      let payload = await getOrg(params.id);
      if (!payload) return;

      const newBreadcrumbData = getBreadcrumbData([], payload, unfilteredData);
      setBreadcrumbData(newBreadcrumbData);
      setCurrentOrgData(payload);
      let { logo } = payload;
      if (logo && logo.length) {
        const imageType = logo
          .split("?")[0]
          .split("/")
          .slice(-1)[0]
          .split(".")[1];
        setOrgImageFileType(imageType);
      }

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }
  useEffect(() => {
    async function getImage() {
      try {
        const response = await getOrgProfileImage(params.id, orgImageFileType);
        setImageUrl(response.data.url);
      } catch (error) {
        setImageUrl("");
        console.log(error);
      }
    }
    if (orgImageFileType?.length) getImage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgImageFileType]);

  return isLoading ? (
    <Box
      component="main"
      sx={{
        alignItems: "center",
        display: "flex",
        flexGrow: 1,
        minHeight: "100%",
        ".MuiDataGrid-virtualScroller": {
          marginTop: "40px !important",
        },
        // bgcolor: "background.paper",
      }}
    >
      <Container maxWidth="xl" component="main">
        <Box sx={{ my: 3 }}>
          <CircularProgress />
        </Box>
      </Container>
    </Box>
  ) : params.id === "overview" ? (
    <>
      <Container maxWidth="xl">
        <Breadcrumbs
          aria-label="breadcrumb"
          maxItems={4}
          // onClick={function noRefCheck() {}}
          role="presentation"
        >
          <Typography color="text.primary">Organizations</Typography>
        </Breadcrumbs>
        {unfilteredData ? (
          <UserOrgsTable unfilteredData={unfilteredData} pageSize={25}/>
        ) : (
          <Skeleton variant="text" height={45} width={300} />
        )}
      </Container>
    </>
  ) : (
    <>
      <Box
        component="main"
        sx={{
          alignItems: "center",
          display: "flex",
          flexGrow: 1,
          minHeight: "100%",
          backgroundColor: "#FFFFFF",
          ".MuiDataGrid-virtualScroller": {
            marginTop: "40px !important",
          },
          ".MuiDataGrid-columnHeaderTitle": {
            fontWeight: 700,
          },
          // bgcolor: "background.paper",
        }}
      >
        <Container maxWidth="md" component="main">
          <Breadcrumbs
            aria-label="breadcrumb"
            maxItems={4}
            // onClick={function noRefCheck() {}}
            role="presentation"
          >
            <Link
              component={RouterLink}
              color="inherit"
              to={`/orgs/tree-view/overview`}
              underline="hover"
            >
              Organizations
            </Link>
            {breadcrumbData.map((breadcrumb, i) => {
              return i === breadcrumbData.length - 1 ? (
                <Typography color="text.primary">{breadcrumb.name}</Typography>
              ) : (
                <Link
                  component={RouterLink}
                  color="inherit"
                  to={`/orgs/tree-view/${breadcrumb.id}`}
                  underline="hover"
                >
                  {breadcrumb.name}
                </Link>
              );
            })}
          </Breadcrumbs>
          <div>
            <Box sx={{ my: 3 }}>
              {/* <Typography color="textPrimary" variant="h4">
                Main
              </Typography>
              <Typography color="textSecondary" gutterBottom variant="body2">
                Edit an Organization
              </Typography> */}
            </Box>

            <Stack direction="column" sx={{ maxWidth: { md: 600 } }}>
              <Grid container spacing={2}>
                <Grid container spacing={2}>
                  <Grid item md={6} xs={12}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        // margin: "15% 5% 0 0",
                      }}
                    >
                      {imageUrl && imageUrl.length > 0 ? (
                        // eslint-disable-next-line jsx-a11y/img-redundant-alt
                        <img
                          alt="profile-image"
                          src={imageUrl}
                          style={{
                            height: "100%",
                            width: "100%",
                            objectFit: "contain",
                          }}
                        />
                      ) : (
                        <InsertPhotoOutlinedIcon
                          fontSize="large"
                          color="disabled"
                          sx={{
                            height: "4.2em",
                            width: "6.2em",
                          }}
                        />
                      )}
                    </div>
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <Typography sx={{ mb: 1 }} color="textPrimary" variant="h4">
                      Organization Information
                    </Typography>
                    <Button
                      startIcon={<Edit />}
                      onClick={() => router.push(`/orgs/${params.id}/edit`)}
                    >
                      Edit
                    </Button>
                    <Grid container spacing={2}>
                      <Grid item md={12} xs={12}>
                        <div>
                          {/* <Business position="end" /> */}
                          <InputLabel>Company or Organization Name:</InputLabel>
                          <Typography>
                            {currentOrgData?.name || "---"}
                          </Typography>
                        </div>
                      </Grid>
                      <Grid item md={12} xs={12}>
                        <div>
                          <InputLabel>@Org_handle :</InputLabel>
                          <Typography>
                            {currentOrgData?.handle || "---"}
                          </Typography>
                        </div>
                      </Grid>
                      <Grid item md={12} xs={12}>
                        {" "}
                        <div>
                          <InputLabel>Display Name :</InputLabel>
                          <Typography>
                            {currentOrgData?.screen_name || "---"}
                          </Typography>
                        </div>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                {/* Contact Info */}
                <Grid item md={12} xs={12}>
                  <Divider />
                  <Typography sx={{ mt: 2 }} color="textPrimary" variant="h4">
                    Contact Information
                  </Typography>
                  <Button
                    startIcon={<Edit />}
                    onClick={() => router.push(`/orgs/${params.id}/edit`)}
                  >
                    Edit
                  </Button>
                </Grid>
                <Grid item md={6} xs={12}>
                  {" "}
                  <div>
                    <InputLabel>Email:</InputLabel>
                    <Typography>
                      {currentOrgData?.support_email || "---"}
                    </Typography>
                  </div>
                </Grid>
                <Grid item md={6} xs={12}>
                  {" "}
                  <div>
                    <InputLabel>Phone:</InputLabel>

                    <Typography>
                      {currentOrgData?.support_phone || "---"}
                    </Typography>
                  </div>
                </Grid>
                <Grid item md={6} xs={12}>
                  {" "}
                  <div>
                    <InputLabel>Website:</InputLabel>

                    <Typography>
                      {currentOrgData?.website?.trim() !== "" ? (
                        <Link
                          href={currentOrgData?.website?.trim()}
                          target="_blank"
                          style={{
                            textDecoration: `${
                              currentOrgData?.website?.trim()
                                ? "inherit"
                                : "none"
                            }`,
                          }}
                        >
                          {currentOrgData?.website}
                        </Link>
                      ) : (
                        "---"
                      )}
                    </Typography>
                  </div>
                </Grid>
                <Grid item md={6} xs={12}>
                  {" "}
                  <div>
                    <InputLabel>Linkedin:</InputLabel>
                    <Typography>
                      {currentOrgData?.linkedin?.trim() !== "" ? (
                        <Link
                          href={currentOrgData?.linkedin?.trim()}
                          target="_blank"
                          style={{
                            textDecoration: `${
                              currentOrgData?.linkedin?.trim()
                                ? "inherit"
                                : "none"
                            }`,
                          }}
                        >
                          {currentOrgData?.linkedin}
                        </Link>
                      ) : (
                        "---"
                      )}
                    </Typography>
                  </div>
                </Grid>
                <Grid item md={6} xs={12}>
                  {" "}
                  <div>
                    <InputLabel>Facebook:</InputLabel>
                    <Typography>
                      {" "}
                      {currentOrgData?.facebook?.trim() !== "" ? (
                        <Link
                          href={currentOrgData?.facebook?.trim()}
                          target="_blank"
                          style={{
                            textDecoration: `${
                              currentOrgData?.facebook?.trim()
                                ? "inherit"
                                : "none"
                            }`,
                          }}
                        >
                          {currentOrgData?.facebook}
                        </Link>
                      ) : (
                        "---"
                      )}
                    </Typography>
                  </div>
                </Grid>

                <Grid item md={6} xs={12}>
                  {" "}
                  <div>
                    <InputLabel>Twitter:</InputLabel>
                    <Typography>
                      {" "}
                      {currentOrgData?.twitter?.trim() !== "" ? (
                        <Link
                          href={currentOrgData?.twitter?.trim()}
                          target="_blank"
                          style={{
                            textDecoration: `${
                              currentOrgData?.twitter?.trim()
                                ? "inherit"
                                : "none"
                            }`,
                          }}
                        >
                          {currentOrgData?.twitter}
                        </Link>
                      ) : (
                        "---"
                      )}
                    </Typography>
                  </div>
                </Grid>

                <Grid item md={6} xs={12}>
                  {" "}
                  <div>
                    <InputLabel>Youtube:</InputLabel>
                    <Typography>
                      {" "}
                      {currentOrgData?.youtube?.trim() !== "" ? (
                        <Link
                          href={currentOrgData?.youtube?.trim()}
                          target="_blank"
                          style={{
                            textDecoration: `${
                              currentOrgData?.youtube?.trim()
                                ? "inherit"
                                : "none"
                            }`,
                          }}
                        >
                          {currentOrgData?.youtube}
                        </Link>
                      ) : (
                        "---"
                      )}
                    </Typography>
                  </div>
                </Grid>

                {/* Mailing Address */}
                <Grid item md={12} xs={12}>
                  <Divider />
                  <Typography sx={{ mt: 2 }} color="textPrimary" variant="h4">
                    Mailing address
                  </Typography>
                  <Button
                    startIcon={<Edit />}
                    onClick={() => router.push(`/orgs/${params.id}/edit`)}
                  >
                    Edit
                  </Button>
                </Grid>
                <Grid item md={6} xs={12}>
                  <div>
                    <InputLabel>Address 1:</InputLabel>
                    <Typography>
                      {currentOrgData?.street_address?.address_line_1 || "---"}
                    </Typography>
                  </div>
                </Grid>

                <Grid item md={6} xs={12}>
                  <div>
                    <InputLabel>Address 2:</InputLabel>
                    <Typography>
                      {currentOrgData?.street_address?.address_line_2 || "---"}
                    </Typography>
                  </div>
                </Grid>
                <Grid item md={6} xs={12}>
                  <div>
                    <InputLabel>City:</InputLabel>
                    <Typography>
                      {currentOrgData?.street_address?.city || "---"}
                    </Typography>
                  </div>
                </Grid>

                <Grid item md={6} xs={12}>
                  <div>
                    <InputLabel>State/Province:</InputLabel>
                    <Typography>
                      {currentOrgData?.street_address?.state_or_province ||
                        "---"}
                    </Typography>
                  </div>
                </Grid>

                <Grid item md={6} xs={12}>
                  <div>
                    <InputLabel>Country / Region</InputLabel>
                    <Typography>
                      {currentOrgData?.street_address?.country_or_region ||
                        "---"}
                    </Typography>
                  </div>
                </Grid>

                <Grid item md={6} xs={12}>
                  <div>
                    <InputLabel>Zip/Postal Code</InputLabel>
                    <Typography>
                      {currentOrgData?.street_address?.postal_code || "---"}
                    </Typography>
                  </div>
                </Grid>

                {/* Shipping Address */}
                <Grid item md={12} xs={12}>
                  <Divider />
                  <Typography sx={{ mt: 2 }} color="textPrimary" variant="h4">
                    Shipping address
                  </Typography>
                  <Button
                    startIcon={<Edit />}
                    onClick={() => router.push(`/orgs/${params.id}/edit`)}
                  >
                    Edit
                  </Button>
                </Grid>
                <Grid item md={6} xs={12}>
                  <div>
                    <InputLabel>Address 1:</InputLabel>
                    <Typography>
                      {currentOrgData?.shipping_address?.address_line_1 ||
                        "---"}
                    </Typography>
                  </div>
                </Grid>

                <Grid item md={6} xs={12}>
                  <div>
                    <InputLabel>Address 2:</InputLabel>
                    <Typography>
                      {currentOrgData?.shipping_address?.address_line_2 ||
                        "---"}
                    </Typography>
                  </div>
                </Grid>
                <Grid item md={6} xs={12}>
                  <div>
                    <InputLabel>City:</InputLabel>
                    <Typography>
                      {currentOrgData?.shipping_address?.city || "---"}
                    </Typography>
                  </div>
                </Grid>

                <Grid item md={6} xs={12}>
                  <div>
                    <InputLabel>State/Province:</InputLabel>
                    <Typography>
                      {currentOrgData?.shipping_address?.state_or_province ||
                        "---"}
                    </Typography>
                  </div>
                </Grid>

                <Grid item md={6} xs={12}>
                  <div>
                    <InputLabel>Country / Region:</InputLabel>
                    <Typography>
                      {currentOrgData?.shipping_address?.country_or_region ||
                        "---"}
                    </Typography>
                  </div>
                </Grid>

                <Grid item md={6} xs={12}>
                  <div>
                    <InputLabel>Zip/Postal Code:</InputLabel>
                    <Typography>
                      {currentOrgData?.shipping_address?.postal_code || "---"}
                    </Typography>
                  </div>
                </Grid>
              </Grid>
            </Stack>
          </div>
        </Container>
      </Box>
    </>
  );
};
